var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CBadge',{staticClass:"tw-uppercase",class:_vm.badgeClasses,attrs:{"bg-class":"tw-bg-red-400","text-class":"tw-text-white"}},[(_vm.$slots.default)?[_vm._t("default")]:[_vm._v("\n    "+_vm._s(_vm.$t('new::badge'))+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }